import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {Content, IonicPage, NavController, NavParams, Platform, ViewController, VirtualScroll} from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-popover-select-department',
  templateUrl: 'popover-select-department.html',
})
export class PopoverSelectDepartmentPage {


  //DepartmentZones values
  /*private selectedDepartment: DepartmentsZones;
  private selectedZone: ZoneType;*/
  @ViewChild(VirtualScroll) virtualScroll: VirtualScroll;
  @ViewChild(Content) content: Content;
  private departmentList = [];
  private departmentSelected;
  generalOffset : string;
  clientHeight : string;
  offsetTopAndroid : string;
  offsetTopIos : string;
  offsetLeftAndroid : string;
  offsetLeftIos : string;
  private tag="[DEPARTMENT SELECTOR]";
  os : string = 'browser';


  /*Pagination*/
  private numberPage = 1;
  private qtyListItemsPerPage = 100;



  private departmentArray = [];
  private departmentArrayToShow = [];
  private totalRows = 0;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private cdr: ChangeDetectorRef,
              public viewCtrl: ViewController,
              private platform: Platform) {
    this.generalOffset = navParams.get('offsetTop');
    this.clientHeight = navParams.get('clientHeight');
    this.departmentList = navParams.get('departmentList');
    this.departmentSelected = navParams.get('departmentSelected');
    this.offsetTopAndroid = navParams.get('offsetTop') + this.clientHeight+'px';
    this.offsetTopIos = this.generalOffset + this.clientHeight +'px';
    // this.offsetLeft = navParams.get('offsetLeft');
    this.offsetLeftAndroid = '10%';
    this.offsetLeftIos = '5%';
  }

  /**
   * Click outside
   * @param {Event} event
   */
  clickOutside(event: Event){
    if(event.target['className'] === 'outsideContainer'){
      this.viewCtrl.dismiss(this.departmentSelected );
    }
  }
  ionViewDidLoad() {
    this.showDepartments();
    if (this.platform.is('ios')) {
      this.os = 'ios'
    }
    else if(this.platform.is('android')){
      this.os = 'android'
    }
  }

  showDepartments() {


    this.departmentArray = [];
    this.departmentArrayToShow = [];

    this.totalRows = this.departmentArray.length;

    for (let tag of this.departmentList) {
      this.departmentArray.push({"name":tag.DeptName});

      this.totalRows += 1;
    }

    if (this.totalRows > 0) {
      if (this.totalRows < this.qtyListItemsPerPage) {
        for (let i = 0; i < this.totalRows; i++) {
          this.departmentArrayToShow.push({"name": this.departmentArray[i].name});
        }
      }
      else {
        for (let i = 0; i < this.qtyListItemsPerPage; i++) {
          this.departmentArrayToShow.push({"name": this.departmentArray[i].name});
        }
      }

      console.log(this.tag, "Department array");
      console.log(this.tag, this.totalRows);
      console.log(this.tag, "Department array list");
      console.log(this.tag, this.departmentArrayToShow);
      this.cdr.detectChanges();
    }
    else {
      this.cdr.detectChanges();
    }


  }

  doInfinite(event: any) {
    console.log(this.tag, "Infinite Scroll");
    if (this.qtyListItemsPerPage * this.numberPage <= this.departmentArray.length) {
      for (let i = (this.numberPage * this.qtyListItemsPerPage); i < ((this.numberPage + 1) * this.qtyListItemsPerPage); i++) {
        if (i < this.departmentArray.length && this.departmentArrayToShow.findIndex(item => item.name === this.departmentArray[i].name) == -1) {
          this.departmentArrayToShow.push({"name":this.departmentArray[i].name});
        }
        else {
          break;
        }
      }
      this.numberPage++;
    }
    event.complete();
    if (this.departmentArray.length==this.departmentArrayToShow.length) {
      event.enable(false);
    }

  }

  selectDepartment(selectedDepartment)
  {
    this.viewCtrl.dismiss(selectedDepartment);
  }
}





// WEBPACK FOOTER //
// ./src/pages/popover-select-department/popover-select-department.ts